"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OkxwalletInjectTonsdkConnector = void 0;
const inject_connector_1 = require("./inject-connector");
const protocol_1 = require("../protocol");
const utils_1 = require("../utils");
const media_1 = require("../utils/media");
class OkxwalletInjectTonsdkConnector extends inject_connector_1.InjectConnector {
    constructor() {
        super();
        this.walletName = 'OKX Wallet extension';
        this.walletNameKey = 'walletModal.mobileConnectionModal.connectInjected';
    }
    checkWalletMatch() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            (_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.tonsdkConnectStorage.synchronizedCache();
            let stored = (_b = this.connectionManager) === null || _b === void 0 ? void 0 : _b.tonsdkConnectStorage.getItem('ton_connect_info_adapter_universal');
            if (!stored || !(stored === null || stored === void 0 ? void 0 : stored.content)) {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.NOT_CONNECTED_ERROR);
            }
            const content = stored === null || stored === void 0 ? void 0 : stored.content;
            let connection = JSON.parse(content);
            let localItem = connection.connectEvent.payload.items.find((item) => {
                if ('name' in item) {
                    return item.name === 'ton_addr';
                }
                return false;
            });
            this.dappInfo = connection.dappInfo;
            let localAddress = undefined;
            if (localItem && 'address' in localItem) {
                localAddress = localItem.address;
            }
            if (!localAddress) {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED);
            }
            (0, utils_1.logDebug)(`inject-connector localTonaddress : ${localAddress}`);
            if ((0, media_1.isDevice)('mobile')) {
                let connectWalletNameSpace;
                let proofItem = undefined;
                connectWalletNameSpace = {
                    namespace: protocol_1.NameSpaceKeyTON,
                    chains: [protocol_1.TON_CHAINS.MAINNET],
                    params: {
                        ton_addr: { name: 'ton_addr' },
                    },
                };
                let requestWalletAccount = yield this.getAccountByRequestWallets(false, false, false, [connectWalletNameSpace], []);
                if (requestWalletAccount && requestWalletAccount.length == 1) {
                    let tonAccount = requestWalletAccount[0];
                    let tonAddr = (_c = tonAccount.data) === null || _c === void 0 ? void 0 : _c.ton_addr;
                    let tonaddress = tonAddr === null || tonAddr === void 0 ? void 0 : tonAddr.address;
                    if (localAddress === tonaddress) {
                        return;
                    }
                }
            }
            else {
                let connectResult = yield window.okxTonWallet.tonconnect.restoreConnection();
                if (connectResult.event === 'connect') {
                    let ton_addr = connectResult.payload.items.find((item) => item.name === "ton_addr").address;
                    if (ton_addr == localAddress) {
                        return;
                    }
                }
            }
            throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED);
        });
    }
}
exports.OkxwalletInjectTonsdkConnector = OkxwalletInjectTonsdkConnector;
